import React from "react";
import Certifications from "../components/Certifications";

function CertificationsPage() {
  return <Certifications />;
}

export default CertificationsPage;